import KmxCloseFilled from '@kmx/mui-icons/KmxCloseFilled';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

interface CartDrawerProps {
  open: boolean;
  onClose: () => void;
}

const CartDrawer = ({ open, onClose }: CartDrawerProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Drawer
      anchor={isDesktop ? 'right' : 'bottom'}
      open={open}
      onClose={onClose}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          pt: 1,
          pr: 1,
          pl: 3,
        }}
      >
        <IconButton
          onClick={onClose}
          size="small"
          autoFocus
          aria-label="Close cart drawer"
        >
          <KmxCloseFilled />
        </IconButton>
      </Box>
      Cart Go here
    </Drawer>
  );
};

export default CartDrawer;
